import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const LEAD_CAPTURE_DROPDOWN = 'LEAD_CAPTURE_DROPDOWN';
export const LEAD_CAPTURE_DROPDOWN_SUCCESS = 'LEAD_CAPTURE_DROPDOWN_SUCCESS';
export const LEAD_CAPTURE_DROPDOWN_FAILURE = 'LEAD_CAPTURE_DROPDOWN_FAILURE';

// Action Creators
export const leadCaptureDropdown = () => ({
  type: LEAD_CAPTURE_DROPDOWN,
});

export const leadCaptureDropdownSuccess = (data) => ({
  type: LEAD_CAPTURE_DROPDOWN_SUCCESS,
  payload: data,
});

export const leadCaptureDropdownFailure = (error) => ({
  type: LEAD_CAPTURE_DROPDOWN_FAILURE,
  payload: error,
});

// Thunk Function
export const leadCaptureDropdownCallAPI = (external) => {
  return async (dispatch) => {
    dispatch(leadCaptureDropdown());
    try {
      const response = await getMethodWithToken(url.leadCaptureDropdown);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(leadCaptureDropdownSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(leadCaptureDropdownFailure(response?.data));
      }
    } catch (error) {
      dispatch(leadCaptureDropdownFailure(error?.message));
    }
  };
};
